import { AxiosResponseHeaders } from 'axios';
import { ValueDateResponseDTO } from '../entities';
import { ValueDateResponseBody } from '../entities/ValueDateResponseDTO';

const valueDateResponseDTOToValueDateResponseAdapter = (
  data: ValueDateResponseDTO,
  headers?: AxiosResponseHeaders,
): ValueDateResponseBody => {
  if (!data.body) {
    throw new Error('Error');
  }

  return data.body;
};

export { valueDateResponseDTOToValueDateResponseAdapter };
